<script>
export default {
  name: "NavigationComponent",
  props: {
    hasUploadedFile: {
      type: Function,
      required: true
    },
    nextStepHandler: {
      type: Function,
      required: true
    },
    showRequireFileErrorsHandler: {
      type: Function,
      required: true
    }
  }
}
</script>

<template>
  <div class="step-nav">
    <div class="row">
      <div class="col-sm-6">
        <router-link to="/cart">Вернуться назад</router-link>
      </div>
      <div class="col-sm-6">
        <a v-if="hasUploadedFile()" @click="nextStepHandler" href="#">Далее</a>
        <a v-else @click="showRequireFileErrorsHandler" href="#" class="disabled">Далее</a>
      </div>
    </div>
  </div>
</template>

<style scoped>

.step-nav {
  margin-top: 20px;
}

.step-nav .row>.col-sm-6:first-child {
  text-align: left;
}

.step-nav .row>.col-sm-6:last-child {
  text-align: right;
}

.step-nav a {
  background-color: #ffffff;
  color: #1b1e21;
  border-radius: 5px;
  padding: 7px;
  border: 1px solid #c7c7c7;
  display: inline-block;
  text-decoration: none;
}

.step-nav a.disabled {
  background-color: #d3d3d3;
}


@media (max-width: 768px) {

  .step-nav .col-sm-6 {
    width: 50%;
  }

}

</style>
